'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var React = require('react'),
    ReactDOM = require('react-dom'),
    toClassString = require('../../../libs/utils').toClassString,
    RectIcon = require('../../Icon/RectIcon'),
    IconValueRight = require('../../Icon/IconValue/IconValueRight'),
    DropdownStringItem = require('./DropdownStringItem'),
    ScrollArea = require('../../ScrollArea/ScrollArea'),
    MixinContentUserEvent = require('../../../mixins/ContentUserEvent');

var Dropdown = React.createClass({
    displayName: 'Dropdown',

    mixins: [MixinContentUserEvent],

    propTypes: {
        items: React.PropTypes.array
    },

    getInitialState: function getInitialState() {
        return {
            open: false,
            selectedItems: {},
            dropdownTitle: '',
            lastPostionTop: 0,
            lastItemWidth: 0
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            items: [], //List of items to show in the dropdown
            itemId: '', //Case items are json object, what is the key of that item
            labelKey: '', //Case items are json object, what will hold the label value
            selected: [], // List of selected items
            placeholder: '', //Place holder text
            multiSelect: false,
            gluePlaceholder: false,
            listItemType: DropdownStringItem,
            maxPopupHeight: 380,
            disabled: false,
            valid: true,
            onChange: function onChange() {},
            bottomArrow: "img/arrow-bottom.png",
            onOpen: function onOpen() {}
        };
    },

    onContentClick: function onContentClick(event) {
        if (this.state.open && !ReactDOM.findDOMNode(this).contains(event.target)) {
            //THIS IS GLOBAL EVENT MAKE SURE NOT TO CHANGE STATE AGAIN AND AGAIN, PREvENT REACT CHECKING CHANGES AGAIN AND AGAIN
            var state = this.state;
            state.open = false;
            this.setState(state);
        }
    },

    onFocus: function onFocus(e) {
        var state = this.state;
        state.focused = true;
        this.setState(state);
    },

    onBlur: function onBlur(e) {
        var state = this.state;
        var relatedTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement;

        state.focused = false;
        if (!(relatedTarget && ReactDOM.findDOMNode(this).contains(relatedTarget))) {
            //THIS IF HANDLE OF CASE WHEN ITEM INSIDE THE DROPDOWN IS FOCUSABLE, LIKE CHECKBOX
            //SO WHEN FOCUSED MOVE TO INNER ELEMENT< THERE IS NO NEED TO CLOSE THE DROPDOWN
            state.open = false;
        }
        this.setState(state);
    },

    onKeyboardKeyDown: function onKeyboardKeyDown(e) {
        switch (e.keyCode) {
            case 38:
                //UP ARROW
                if (this.state.open) {
                    var selectedIndex = this._getSelectedIndex();
                    if (selectedIndex > 0) {
                        this._updateSelectionChange(this.props.items[--selectedIndex], true, e);
                        e.stopPropagation();
                        e.preventDefault();

                        return false;
                    }
                }
                break;

            case 40:
                //DOWN ARROW
                if (this.state.open) {
                    var selectedIndex = this._getSelectedIndex();
                    if (selectedIndex < this.props.items.length - 1) {
                        this._updateSelectionChange(this.props.items[++selectedIndex], true, e);
                        e.stopPropagation();
                        e.preventDefault();

                        setTimeout(function () {
                            this._scrollToSelected();
                        }.bind(this));

                        return false;
                    }
                } else if (this.state.focused) {
                    if (this.props.disabled === true) {
                        return;
                    }
                    this._openDropdown();
                }
                break;

            case 13:case 27:
                //ENTER
                if (this.state.open) {
                    var state = this.state;
                    state.open = false;
                    this.setState(state);
                }
                break;

            case 9:
                //TAB DON'T CATCH TYPING EVENTS
                /*     var state = this.state;
                     state.open = false;
                     this.setState(state);
                     */
                break;

            default:
                var searchString = String.fromCharCode(e.keyCode);
                if (Date.now() - this.lastKeyboardTypeTime > 800) {
                    this.lastKeyboardTyped = "";
                }
                searchString = this.lastKeyboardTyped + searchString;
                this._selectByLetter(searchString, e);

                this.lastKeyboardTyped = searchString;
                this.lastKeyboardTypeTime = Date.now();
        }
    },

    _selectByLetter: function _selectByLetter(char, event) {
        var index = this.lastCharSelectedIndex;

        var newIndex = this._findNextByLetterFromIndex(index, char);
        if (newIndex == -1) {
            newIndex = this._findNextByLetterFromIndex(0, char);
        }

        if (newIndex > -1) {
            this.lastCharSelectedIndex = newIndex;
            this._updateSelectionChange(this.props.items[newIndex], true, event);
        }
    },

    _findNextByLetterFromIndex: function _findNextByLetterFromIndex(fromIndex, char) {
        for (var index = fromIndex; index < this.props.items.length; index++) {

            if (this.lastCharSelectedIndex != index) {
                var item = this.props.items[index];
                var checkValue = item;
                if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object') {
                    checkValue = item[this.props.labelKey];
                }
                checkValue = checkValue.toString();

                if (checkValue.trim().toLowerCase().startsWith(char.trim().toLowerCase())) {
                    return index;
                }
            }
        }
        return -1;
    },

    _scrollToSelected: function _scrollToSelected() {
        var selected = this.refs["selected-item"];
        if (selected) {
            var domEl = ReactDOM.findDOMNode(selected);
            var scrollArea = this.refs["scroll-area"];

            scrollArea.scrollToRect(domEl.offsetTop - domEl.offsetHeight - 5, domEl.offsetTop + domEl.offsetHeight);
        }
    },

    _getSelectedIndex: function _getSelectedIndex() {
        if (this.props.multiSelect == false && this.props.selected.length > 0) {
            var selectedItem = this.props.selected[0];
            for (var i = 0; i < this.props.items.length; i++) {
                var item = this.props.items[i];
                if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object') {
                    if (item[this.props.itemId] == selectedItem[this.props.itemId]) {
                        return parseInt(i);
                    }
                } else if (item == selectedItem) {
                    return parseInt(i);
                }
            }
        }

        return this.props.items.length > 0 ? 0 : -1;
    },

    ddClicked: function ddClicked(event) {

        if (this.props.disabled === true) {
            return;
        }

        if (this.refs["dd-current"].contains(event.target)) {
            //Ignore clicks in the popup

            if (!(this.state.open && this.props.multiSelect)) {
                if (this.state.open) {
                    this._closeDropdown();
                } else {
                    this._openDropdown();
                }
            }
        }
    },

    _openDropdown: function _openDropdown() {
        var event = new CustomEvent('dropdown-open');
        document.dispatchEvent(event);

        var state = this.state;
        state.open = true;
        this.setState(state);
        this.props.onOpen();
    },

    _closeDropdown: function _closeDropdown() {
        var state = this.state;
        state.open = false;
        this.setState(state);
    },

    loadStateFromProps: function loadStateFromProps(newProps) {
        var state = this.state;

        state.selectedItems = {};
        for (var i = 0; i < newProps.selected.length; i++) {
            var selectedItemKey = newProps.selected[i];
            var selectedItem = newProps.selected[i];
            if ((typeof selectedItem === 'undefined' ? 'undefined' : _typeof(selectedItem)) == "object") {
                selectedItemKey = selectedItem[newProps.itemId];
            }
            state.selectedItems[selectedItemKey] = selectedItem;
        }

        state.dropdownTitle = this.generateTitleString();

        this.setState(state);
    },

    componentDidMount: function componentDidMount() {
        this.lastKeyboardTypeTime = Date.now();
        this.lastKeyboardTyped = "";
        this.lastCharSelectedIndex = this._getSelectedIndex();

        this.loadStateFromProps(this.props);

        this._storePosition();

        this.height = this.refs.dropdown.offsetHeight;

        ReactDOM.findDOMNode(this).addEventListener('keydown', this.onKeyboardKeyDown);
    },

    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
        this.loadStateFromProps(newProps);
    },

    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener('dropdown-open', this._dropdownGlobalOpen);
        ReactDOM.findDOMNode(this).removeEventListener('keydown', this.onKeyboardKeyDown);
    },

    _dropdownGlobalOpen: function _dropdownGlobalOpen() {
        if (this.state.open) {
            this._closeDropdown();
        }
    },

    _updateSelectionChange: function _updateSelectionChange(item, scrollToSelection, event) {
        var state = this.state;
        var id = item;
        if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object') {
            id = item[this.props.itemId];
        }

        if (this.props.multiSelect) {
            if (state.selectedItems[id]) {
                delete state.selectedItems[id];
            } else {
                state.selectedItems[id] = item;
            }
        } else {
            var keys = Object.keys(state.selectedItems);
            // if(id == keys[0]) {
            // state.selectedItems = {};
            // } else {
            state.selectedItems = {};
            state.selectedItems[id] = item;
            // }
        }

        state.dropdownTitle = this.generateTitleString();
        this.setState(state);

        var keys = Object.keys(state.selectedItems);
        var eventResult = [];
        keys.forEach(function (key) {
            eventResult.push(state.selectedItems[key]);
        });

        this.props.onChange.call(this, eventResult, event);

        if (scrollToSelection) {
            setTimeout(function () {
                this._scrollToSelected();
            }.bind(this));
        }
    },

    onListItemClicked: function onListItemClicked(item, event) {

        this._updateSelectionChange(item, false, event);

        if (this.props.multiSelect == false) {
            var state = this.state;
            state.open = false;
            this.setState(state);
        }
    },

    generateTitleString: function generateTitleString() {
        var selectedKeys = Object.keys(this.state.selectedItems);
        var selectedTitle = this.props.placeholder || "";

        if (this.props.gluePlaceholder == false && selectedKeys.length > 0) {
            selectedTitle = "";
            for (var i = 0; i < selectedKeys.length; i++) {
                var selectedKey = selectedKeys[i];
                if (i > 0) {
                    selectedTitle += ", ";
                }

                var value = this.state.selectedItems[selectedKey];
                if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == "object") {
                    selectedTitle += value[this.props.labelKey];
                } else {
                    selectedTitle += selectedKeys[i];
                }
            }
        }

        return selectedTitle;
    },

    componentDidUpdate: function componentDidUpdate() {
        this._storePosition();
    },

    _storePosition: function _storePosition() {
        var el = ReactDOM.findDOMNode(this);
        var clientTop = el.offsetTop - window.scrollY + 20;
        if (clientTop < 0 || isNaN(clientTop)) {
            clientTop = 0;
        }

        var state = this.state;
        /**
         *
         *
         * PAY ATTANTION TO THIS CONDITION,
         * THIS METHOD IS CALLED INSIDE "componentDidUpdate".
         * MEANING WE MUST UPDATE THE STATE ONLY IF STATE IS CHANGED
         *
         * WHILE RUNNING UINT TESTING 'el' HAVE NO offsetTop, added check for isNaN
         */
        if (state.lastPostionTop != clientTop || state.lastItemWidth != el.offsetWidth) {
            state.lastPostionTop = clientTop;
            state.lastItemWidth = el.offsetWidth;

            this.setState(state);
        }
    },

    render: function render() {
        var usePlaceHolder = Object.keys(this.state.selectedItems).length == 0;
        var popupClass = "dd-popup " + (this.state.open ? "open " : " ");

        var popupHeight = this.props.maxPopupHeight;

        var screenCurrentHeight = window.innerHeight || document.documentElement.clientHeight;
        var actualLeftPixels = screenCurrentHeight - this.state.lastPostionTop;
        if (actualLeftPixels < 100) {
            actualLeftPixels = 100;
        };
        if (actualLeftPixels < popupHeight) {
            popupHeight = actualLeftPixels;
        }

        var popupStyle = {
            maxHeight: popupHeight
        };
        if (this.height) {
            popupStyle.top = this.height + 5 + "px";
        }

        var items = [];
        for (var i = 0; i < this.props.items.length; i++) {
            var currentItem = this.props.items[i];

            var itemProps = {
                onListItemClicked: this.onListItemClicked
            };
            if ((typeof currentItem === 'undefined' ? 'undefined' : _typeof(currentItem)) == "object") {
                itemProps.key = currentItem[this.props.itemId];
                itemProps.selected = this.state.selectedItems[currentItem[this.props.itemId]] || false;
                itemProps.item = currentItem;
                itemProps.label = currentItem[this.props.labelKey];
                Object.assign(itemProps, currentItem);
            } else {
                itemProps.key = currentItem;
                itemProps.item = currentItem;
                itemProps.label = currentItem;
                itemProps.selected = this.state.selectedItems[currentItem] || false;
            }
            if (itemProps.selected) {
                itemProps.ref = "selected-item";
            }
            var el = React.createElement(this.props.listItemType, itemProps);

            items.push(el);
        }

        var triangleLeft = this.state.lastItemWidth - 14;
        if (triangleLeft < 9) {
            triangleLeft = 9;
        }
        var triangleClass = (this.state.open ? "dd-triangle-show" : "") + " dd-triangle";
        var triangleStyle = { left: triangleLeft + "px" };

        var ddClasses = toClassString("dropdown", this.props.disabled === true ? "disabled" : "", this.props.className);

        var dropdownProps = {
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            className: ddClasses,
            onClick: this.ddClicked
        };

        if (this.props.disabled === false) {
            dropdownProps.tabIndex = 0;
        }

        return React.createElement(
            'div',
            _extends({ ref: 'dropdown' }, dropdownProps),
            React.createElement(
                'div',
                { className: "dd-current fields-tbl f-t-middle " + (this.props.disabled === true ? "" : "clickable"), ref: 'dd-current' },
                React.createElement(
                    IconValueRight,
                    { icon: this.props.bottomArrow, className: (usePlaceHolder ? "placeholder" : "") + " txt" },
                    React.createElement(
                        'div',
                        { className: "dd-current-text " + (this.props.valid == false ? "invalid" : "") },
                        this.state.dropdownTitle
                    )
                )
            ),
            React.createElement(
                'div',
                { className: popupClass, style: popupStyle },
                this.state.open ? React.createElement(
                    ScrollArea,
                    { height: popupHeight - 43, ref: 'scroll-area' },
                    React.createElement(
                        'div',
                        { className: 'dd-items-wrap' },
                        items
                    )
                ) : null
            ),
            React.createElement('div', { className: triangleClass, style: triangleStyle })
        );
    }
});

module.exports = Dropdown;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/Dropdown/Dropdown.js
// module id = 138
// module chunks = 0 1 2 3 5 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26